/* src/views/jour/proto/JourControleProto.jsx — L'ÉCRAN CONTRÔLE d'Aujourd'hui,
   transcrit de docs/handoff/aujourdhui-complet.jsx (JourControle). LE DESSIN,
   PAS LA LOGIQUE : nav de mois, trois stats (contrôlés / à reprendre / à
   contrôler), la légende des huit tips, puis une carte par ménage TERMINÉ du
   mois : logement, agent, heure, tips d'état, la checklist et sa bande de
   photos, « Contrôler » / « Confier ». Styles copiés tels quels. */

import React from 'react'
import { NavMoisJour, StatsTrio } from './JourChrome'
import { TipRond } from '../../accueil/proto/EcranAccueilProto'

/* La légende — les huit états, avec les MÊMES tips que les lignes. */
const LEGENDE = [
  ['valide', 'ménage validé'],
  ['incident_a_juger', 'incident à juger'],
  ['incident_regle', 'incident réglé'],
  ['ctrl_ras', 'contrôlé, rien à signaler'],
  ['ctrl_reprendre', 'contrôlé, à reprendre'],
  ['ctrl_designe', "à contrôler, quelqu'un est dessus"],
  ['hors_fenetre', 'hors fenêtre'],
  ['ctrl_personne', 'à contrôler, personne dessus'],
]

/* Le tip « hors fenêtre » (œil barré) n'existe pas dans l'accueil — le voici,
   tel que le fichier le dessine. */
export function TipHorsFenetre() {
  return (
    <span className="tip" data-tip="Hors fenêtre de contrôle"
      style={{ width: '21px', height: '21px', borderRadius: '50%', background: '#f1f4f7',
        border: '1.5px solid #dde4ea', display: 'inline-flex', alignItems: 'center',
        justifyContent: 'center', flexShrink: '0' }}>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#c3cdd6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
        <path d="m3 3 18 18" />
      </svg>
    </span>
  )
}

const RendTip = ({ variante, onClic, testId }) => (variante === 'hors_fenetre'
  ? <TipHorsFenetre />
  : <TipRond variante={variante} onClic={onClic} testId={testId} />)

export function LegendeControle() {
  return (
    <div style={{ background: '#fff', border: '1px solid var(--bord)',
      borderRadius: '12px', padding: '10px 12px', display: 'flex', gap: '14px',
      flexWrap: 'wrap', fontSize: '10.5px', color: 'var(--gris)' }}
      data-testid="controle-legende">
      {LEGENDE.map(([v, lb]) => (
        <span key={v} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <RendTip variante={v} />{lb}</span>
      ))}
    </div>
  )
}

/* ── une carte de ménage à contrôler ──────────────────────────────── */
export function CarteControle({ logement, sous, tips = [], checklist, tagChecklist,
  photos = [], onPhoto, onControler, onConfier, testId }) {
  return (
    <div className="carte" style={{ margin: '0 0 9px' }} data-testid={testId}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '9px',
        marginBottom: '9px' }}>
        <span style={{ flex: '1', minWidth: '0' }}>
          <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600',
            color: 'var(--navy-d)' }}>{logement}</span>
          <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
            marginTop: '1px' }}>{sous}</span>
        </span>
        {tips.map((t, i) => (
          <RendTip key={i} variante={t.variante} onClic={t.onClic} testId={t.testId} />
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px',
        padding: '8px 10px', background: '#f6f8fa', borderRadius: '10px',
        marginBottom: '8px' }}>
        <span style={{ flex: '1', fontSize: '11.5px',
          color: 'var(--navy-d)' }}>{checklist}</span>
        {tagChecklist && <span className="tag t-a">{tagChecklist}</span>}
      </div>
      <div style={{ display: 'flex', gap: '6px', overflowX: 'auto',
        scrollbarWidth: 'none', touchAction: 'pan-x', margin: '0 -2px',
        padding: '0 2px 2px' }}>
        {photos.map((ph, i) => (
          <button key={i} onClick={() => onPhoto(ph, i)}
            data-testid={testId ? `${testId}-photo-${i}` : undefined}
            style={{ flex: '0 0 84px', height: '84px', borderRadius: '10px',
              background: '#e6eaee', border: '1px solid var(--bord)', color: '#98a2ad',
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              justifyContent: 'center', gap: '3px' }}>
            <span style={{ fontSize: '15px' }}>◫{ph.n > 1 ? ` ×${ph.n}` : ''}</span>
            <span style={{ fontSize: '8.5px', color: 'var(--gris-d)' }}>{ph.piece}</span>
          </button>
        ))}
      </div>
      {(onControler || onConfier) && (
        <div className="act" style={{ marginTop: '10px' }}>
          {onControler && <button className="bt bt-p"
            data-testid={testId ? `${testId}-controler` : undefined}
            onClick={onControler}>Contrôler</button>}
          {onConfier && <button className="bt bt-s"
            data-testid={testId ? `${testId}-confier` : undefined}
            onClick={onConfier}>Confier</button>}
        </div>
      )}
    </div>
  )
}

export function JourControleProto({ mois, stats, cartes, enfantsApres }) {
  return (
    <div className="page">
      <NavMoisJour testId="controle-mois" label={mois.label} n={mois.n}
        onPrec={mois.onPrec} onSuiv={mois.onSuiv} suivActif={mois.suivActif} />
      <StatsTrio items={[
        { n: stats.controles, lb: 'Contrôlés', fond: '#2f9e6e' },
        { n: stats.aReprendre, lb: 'À reprendre', fond: '#b8412b' },
        { n: stats.aControler, lb: 'À contrôler', fond: '#d98c1f' },
      ]} />
      <LegendeControle />
      <div style={{ marginTop: '9px' }}>
        {cartes.map((c, i) => <CarteControle key={i} {...c} />)}
      </div>
      {enfantsApres}
    </div>
  )
}
